import { React, useState, useEffect, useCallback } from "react";
import Page from "../Page";
import EventsCalendar from "../Calendar/EventsCalendar";

const MyCoachingServicesPage = (event) => {
  const [isLoading, setIsLoading] = useState(true);
  const [selectedSessionFromHome, setSelectedSessionFromHome] = useState({});
  const [selectedSessionPos, setSelectedSessionPos] = useState(0);

  return (
    <>
  <Page> 
        <EventsCalendar
          isHome={false}
          isLearn={false}
          marketingDateRange={null}
          setSelectedSessionFromHome={setSelectedSessionFromHome}
          selectedSessionPos={selectedSessionPos}
          setSelectedSessionPos={setSelectedSessionPos}
          isMobile={false}
          isEvents={false}
          isCoaching={true}
          isMyCoaching={true}
        />
       </Page> 
    </>
  );
};

export default MyCoachingServicesPage;
